<router-outlet></router-outlet>
<sbmn-error-dialog></sbmn-error-dialog>
